import { registerArchetype } from './index.js';
import { getRuntimes } from '../combat.js';
registerArchetype({
    id: 'revive',
    apply: ({ state, source, params }) => {
        const hpPct = params.hpPct ?? 0.3;
        const r = getRuntimes(state, source.side)[source.slot];
        r.reviveAvailable = true;
        r.statuses.push({
            id: `revive_${source.slot}`,
            kind: 'buff',
            remainingTicks: Number.MAX_SAFE_INTEGER,
            params: { reviveHpPct: hpPct }
        });
    }
});
